<!--
/*******************************************************************************
*@ 컴포넌트명   : FvrtAcnModPopup.vue
*@ 컴포넌트설명 : 자주 보는 계좌 - 설정 변경
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" :btn-area-padding="true" title="MMAIN-03-04-06-01" class="bg-gray">
      <template #content>
        <ul class="account-setting-list">
          <li class="list-item">
            <!-- 계좌정보 -->
            <div class="account-info">
              <div class="badge-setting -type2">
                {{
                  fvrtAcnTmp.acnoKnd == "1"
                    ? fvrtAcnTmp.acnoKnd2 == "3"
                      ? /*입출금*/ $t("MMAIN-03-02-01-02")
                      : /*예/적금*/ $t("MMAIN-03-02-01-03")
                    : /*대출*/ $t("MMAIN-03-02-01-04")
                }}
              </div>
              <div class="item title">
                <div class="account">
                  {{ fvrtAcnTmp.acno }}
                  <span class="nation">{{ `(${fvrtAcnTmp.cncycd})` }}</span>
                </div>
              </div>
              <div class="item name">{{ fvrtAcnTmp.acnoAls }}</div>
            </div>
          </li>
        </ul>
        <ul class="account-setting-list">
          <li class="list-item">
            <div class="tit">{{ /*배경 색상*/ $t("MMAIN-03-04-06-02") }}</div>
            <div class="dec">
              <span class="item-color" :class="`-${_.isEmpty(fvrtAcnTmp.colrCdCtnt) ? 'type1' : fvrtAcnTmp.colrCdCtnt}`" @click="setAcnColor()"></span>
            </div>
          </li>
        </ul>
        <ul class="account-setting-list">
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 != '2'">
            <div class="tit">{{ /*금액 표시*/ $t("MMAIN-03-04-06-03") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.amtRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-else>
            <div class="tit">{{ /*이자 납입 금액 표시*/ $t("MMAIN-03-04-08-01") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.intPamtRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <!-- <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2=='3'">
            <div class="tit">{{ /*당일 입/출금 합계 표시*/ $t("MMAIN-03-04-06-04") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="fvrtAcnTmp.ttddRcdrwSumRepsntYn"
                  true-value="1"
                  false-value="0"
                />
                <span class="slider round"></span>
              </div>
            </div>
          </li>-->
        </ul>
        <ul class="account-setting-list">
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '3'">
            <div class="tit">{{ /*출금 가능 금액 표시*/ $t("MMAIN-03-04-06-05") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.drwotAblamtRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '3'">
            <div class="tit">{{ /*신규일 표시*/ $t("MMAIN-03-04-06-06") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.newYmdRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '4'">
            <div class="tit">{{ /*예금 이율 표시*/ $t("MMAIN-03-04-07-01") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.dpostIrtRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '4'">
            <div class="tit">{{ /*계약 기간 표시*/ $t("MMAIN-03-04-07-02") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.ctrcTrmRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '4'">
            <div class="tit">{{ /*갱신일 표시*/ $t("MMAIN-03-04-07-03") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.updatYmdRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '2'">
            <div class="tit">{{ /*대출 금액 표시*/ $t("MMAIN-03-04-08-02") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.lnAmtRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '2'">
            <div class="tit">{{ /*대출 잔액 표시*/ $t("MMAIN-03-04-08-03") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.lnBalRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item" v-if="fvrtAcnTmp.acnoKnd2 == '2'">
            <div class="tit">{{ /*만기일 표시*/ $t("MMAIN-03-04-08-04") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.expirYmdRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
          <li class="list-item">
            <div class="tit">{{ /*계좌 상태 표시*/ $t("MMAIN-03-04-08-05") }}</div>
            <div class="dec">
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" v-model="fvrtAcnTmp.acnStusRepsntYn" true-value="1" false-value="0" />
                <span class="slider round"></span>
              </div>
            </div>
          </li>
        </ul>
      </template>
      <template #footer>
        <button class="btn md normal" @click="onFvrtAcnSetCfm()">{{ /*설정 저장하기*/ $t("MMAIN-03-04-06-08") }}</button>
      </template>
    </popup>
    <!-- action sheet 들어 가는 곳 -->
    <action-sheet :opened.sync="openedSetColor" :action-header="true" :action-footer="true" :use-top-border="true" title="MMAIN-03-04-06-09" class="main-action">
      <template #content>
        <div class="form-check-group color-check">
          <div class="form-check color-type" v-for="v in colrCdArr" :key="v.id">
            <input type="radio" :id="`colrCd${v.id}`" name="colrCd" class="form-check-input" :value="v.value" v-model="colrCd" />
            <label :for="`colrCd${v.id}`" :class="`item-color -${v.value}`"></label>
          </div>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="setAcnColorCfm()">{{ /*색상 선택 완료*/ $t("MMAIN-03-04-06-10") }}</button>
      </template>
    </action-sheet>
  </article>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: ["opened"],
  components: {},
  mounted() {
    //컬러값 생성
    this.colrCdArr = [];
    for (let i = 1; i <= 9; i++) {
      this.colrCdArr.push({ cd: 1, value: "type" + i });
    }
  },
  data() {
    return {
      colrCd: "",
      colrCdArr: [{ cd: 0, value: "type0" }], //색상값
      openedSetColor: false, //색상설정
    };
  },
  computed: {
    ...mapFields("common/main", ["RBF0404L40", "fvrtAcnTmp"]),

    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        if (!value) this.fvrtAcnTmp = {};

        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    setAcnColor() {
      this.colrCd = this.fvrtAcnTmp.colrCdCtnt;
      this.openedSetColor = true;
    },
    setAcnColorCfm() {
      this.fvrtAcnTmp.colrCdCtnt = this.colrCd;
      this.openedSetColor = false;
    },
    onFvrtAcnSetCfm() {
      this.$emit("change", this.fvrtAcnTmp);
      this.openData = false;
    },
  },
};
</script>
